
    export enum SurveyType {
        None = 0,
        Activity = 1,
        General = 2
    }